import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  ModalController
} from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { Idol } from "../../app/app.models";
import { IdolprofilePage } from "../idolprofile/idolprofile";
import { IdolsFetchAction } from "../../app/app.actions";
import { NodeService } from "../../services/node.service";
import { ConfigService } from "../../services/config.service";
import * as firebase from "firebase";
import { IdolsStorageService } from "../../services/idols.storage.service";
import { FannelPage } from "../fannel/fannel";
import { FannelInfoPage } from "../fannel-info/fannel-info";
import {
  AngularFireDatabase,
  FirebaseListObservable
} from "angularfire2/database";

import { AppUtilities } from "../../app/app.utilities";

import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-fannels-list",
  templateUrl: "fannels-list.html"
})
export class FannelsListPage {
  public groups$: Array<Idol[]> = [];
  public idols$: Idol[] = [];
  idolsSC: any[];
  public fannelPage = FannelPage;
  public idolprofilePage = IdolprofilePage;
  public titles$: String[] = [];
  public refresh;
  idolsStorage: Idol[];
  items: FirebaseListObservable<any>;
  listIdols: any[];
  idolsList: any[];
  fannels: any = {};
  numIdols: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    private idolsStorageService: IdolsStorageService,
    public afDatabase: AngularFireDatabase,
    private nodeService: NodeService,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private utils: AppUtilities,
    private translate: TranslateService,
    public modalCtrl: ModalController
  ) {
    this.getIdols();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad FannelsListPage");
  }
  ionViewWillEnter() {}

  doRefresh($event) {
    this.refresh = $event;
    this.getIdols();
    $event.complete();
  }

  getIdols1() {
    var LOADING_IDOLS = this.translate.instant("LOADING_IDOLS");
    this.utils.loading(LOADING_IDOLS);
    //Prodcution
    this.items = this.afDatabase.list("/prod_idols");
    this.items.subscribe(items => {
      firebase
        .database()
        .ref("/prod_fannels")
        .once("value")
        .then((snapshot: any) => {
          this.fannels = snapshot.val();
          this.listIdols = [];
          for (var x = 0; x < items.length; x++) {
            var person = items[x];
            person.name =
              person.name.charAt(0).toUpperCase() + person.name.slice(1);
            this.listIdols.push({
              displayName: person.name,
              name: person.name,
              address: person.address,
              mainImageUrl: person.mainImageUrl,
              category: person.category,
              photoUrl: person.photoUrl,
              description: person.description,
              featuredImageUrl: person.featuredImageUrl,
              facebookUrl: person.facebookUrl,
              twitterUrl: person.twitterUrl,
              instagramUrl: person.instagramUrl,
              uid: person.uid
            });
          }

          this.getNameWithoutAccents();
          this.orderIdols();
          this.utils.loadingDismiss();
        })
        .catch(err => {
          this.utils.loadingDismiss();
        });
    });

    //test
    /*
    this.items.subscribe(items => {
      firebase
        .database()
        .ref('/fannels')
        .once('value')
        .then((snapshot: any) => {
          this.fannels = snapshot.val();
          this.listIdols = [];
          for (var x = 0; x < items.length; x++) {
            var person = items[x];
            person.name =
              person.name.charAt(0).toUpperCase() + person.name.slice(1);
            this.listIdols.push({
              displayName: person.name,
              name: person.name,
              address: person.address,
              mainImageUrl: person.mainImageUrl,
              category: person.category,
              photoUrl: person.photoUrl,
              description: person.description,
              featuredImageUrl: person.featuredImageUrl,
              facebookUrl: person.facebookUrl,
              twitterUrl: person.twitterUrl,
              instagramUrl: person.instagramUrl,
              uid: person.uid
            });
          }
          this.numIdols = this.listIdols.length;
          this.getNameWithoutAccents();
          this.orderIdols();
          this.utils.loadingDismiss();
        })
        .catch(err => {
          this.utils.loadingDismiss();
        });
    });*/
  }

  getIdols() {
    var LOADING_IDOLS = this.translate.instant("LOADING_IDOLS");
    this.utils.loading(LOADING_IDOLS);
    //Prodcution
    firebase
      .database()
      .ref("/prod_idols/")
      .once("value")
      .then((snapshot: any) => {
        var itemsUID = snapshot.val();
        var items = [];
        firebase
          .database()
          .ref("/prod_fannels")
          .once("value")
          .then((snapshot: any) => {
            this.fannels = snapshot.val();

            var uids = Object.keys(itemsUID);
            uids.forEach(uid => {
              items.push(itemsUID[uid]);
            });

            this.listIdols = [];
            for (var x = 0; x < items.length; x++) {
              var person = items[x];
              person.name =
                person.name.charAt(0).toUpperCase() + person.name.slice(1);
              this.listIdols.push({
                displayName: person.name,
                name: person.name,
                address: person.address,
                mainImageUrl: person.mainImageUrl,
                category: person.category,
                photoUrl: person.photoUrl,
                description: person.description,
                featuredImageUrl: person.featuredImageUrl,
                facebookUrl: person.facebookUrl,
                twitterUrl: person.twitterUrl,
                instagramUrl: person.instagramUrl,
                uid: person.uid
              });
            }

            this.getNameWithoutAccents();
            this.orderIdols();
            this.utils.loadingDismiss();
          })
          .catch(err => {
            this.utils.loadingDismiss();
          });
      })
      .catch(err => {
        this.utils.loadingDismiss();
      });
  }

  isFannelOpen(fannel) {
    var open = false;
    for (var i in fannel) {
      if (fannel[i].periode > Date.now()) {
        console.log("Fannel-" + i + " periode " + fannel[i].periode);
        open = true;
      }
    }
    return open;
  }

  goFannel(idol) {
    this.navCtrl.push(FannelPage, { idol: idol });
  }

  getItems(ev: any) {
    // Reset items back to all of the items

    // set val to the value of the searchbar
    const val = ev.target.value;

    //this.sortIdols();
    this.orderIdols();
    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      for (var i = 0; i < this.groups$.length; i++) {
        this.groups$[i] = this.groups$[i].filter((item: any) => {
          console.log("item to search " + JSON.stringify(item));

          return item["name"].toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
      }
      console.log("this.groups$ filtrado ", this.groups$);
      console.log("Titels " + JSON.stringify(this.titles$));
    }

    var arrayGroup: any[] = [];
    var arrayTitle: any[] = [];

    for (var z = 0; z < this.groups$.length; z++) {
      if (this.groups$[z].length != 0) {
        arrayGroup.push(this.groups$[z]);
        arrayTitle.push(this.titles$[z]);
      }
    }
    this.groups$ = arrayGroup;
    this.titles$ = arrayTitle;
  }

  orderIdols() {
    var idols: any[] = [];
    this.listIdols.forEach(idol => {
      if (this.fannels && this.fannels[idol.address]) {
        console.log(
          "Fannel Open ? " + this.isFannelOpen(this.fannels[idol.address])
        );
        if (this.isFannelOpen(this.fannels[idol.address])) {
          console.log("Fannel open");
          idol.fannel = this.isFannelOpen(this.fannels[idol.address]);
          idols.push(idol);
        }
      }
    });
    console.log("Idols ", idols);
    this.numIdols = idols.length;
    if (idols && typeof idols.sort === "function") {
      this.groups$ = [];
      this.titles$ = [];

      this.idols$ = idols;

      // Sort all idols alphabetically
      idols.sort((a: Idol, b: Idol) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      });

      // Group idols by first character
      idols.forEach((idol: Idol) => {
        let charAt = idol.name.charAt(0).toUpperCase();
        let indexOf = this.titles$.indexOf(charAt);

        if (indexOf === -1) {
          // Add character to titles
          this.titles$.push(charAt);
          // Update indexOf new title
          indexOf = this.titles$.indexOf(charAt);
          // Create new group with same indexOf
          this.groups$[indexOf] = [];
        }
        this.groups$[indexOf].push(idol);
      });
    }
  }

  getNameWithoutAccents() {
    for (var x = 0; x < this.listIdols.length; x++) {
      this.listIdols[x].name = this.deleteAccents(
        this.listIdols[x].name.toLowerCase()
      );
      console.log("fans no accents ", this.listIdols[x]);
    }
  }

  deleteAccents(cadena) {
    var chars = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      à: "a",
      è: "e",
      ì: "i",
      ò: "o",
      ù: "u",
      ñ: "n",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      À: "A",
      È: "E",
      Ì: "I",
      Ò: "O",
      Ù: "U",
      Ñ: "N"
    };
    var expr = /[áàéèíìóòúùñ]/gi;
    var res = cadena.replace(expr, function(e) {
      return chars[e];
    });
    return res;
  }

  goInfo() {
    const modal = this.modalCtrl.create(FannelInfoPage);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fannels-list/fannels-list.ts